import { C, P0, R, S, abs, disc, max, min, moodK } from '../../geometry';

export const ticks = {
  name: 'Ticks',
  colors: ['#161616', '#E5484D'],
  draw(m, t) {
    let r0 = 30,
      spin = 0,
      pose = P0();
    const len = (i) => {
      if (m === 'happy') return 9 + 3 * abs(S(t * 7 - i * 0.5));
      // Thinking: a bright tick runs round like a second hand.
      if (m === 'thinking') {
        const head = (t * 7) % 12,
          d0 = abs(i - head),
          d = Math.min(d0, 12 - d0);
        return 4 + 10 * Math.exp((-d * d) / 1.4);
      }
      if (m === 'talking') return 5 + 5 * max(0, S(t * 10));
      if (m === 'surprised') return 12;
      if (m === 'paused') return 0.01;
      return 5 + S(t * 1.6 + i * 0.5);
    };
    if (m === 'happy') {
      spin = 8 * S(t * 5);
      pose.ty = -2 * abs(S(t * 6));
    }
    if (m === 'paused') r0 = 28;
    const strokes = [...Array(12)].map((_, i) => {
      const a = (i * 30 - 90) * R,
        L = len(i);
      return {
        c: i % 3 ? 'a' : 'b',
        pts: [
          [50 + r0 * C(a), 52 + r0 * S(a)],
          [50 + (r0 + L) * C(a), 52 + (r0 + L) * S(a)],
        ],
        spin,
      };
    });
    return { strokes, eyes: { x: 50, y: 52 }, pose };
  },
  eyesOn: 'a',
  solid(f, m, t) {
    f.strokes.unshift({
      c: 'a',
      fill: true,
      pts: disc(50, 52, 20 * moodK(m, t)),
      n: 24,
    });
    return f;
  },
};
